<template>
  <div class="page_declare">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="topForm flex">
          <el-form :inline="true" :model="listQuery2" label-width="80px" v-if="activeName > 1">
            <el-form-item label="项目">
              <el-select v-model="listQuery2.Projectid" placeholder="" value-key="Projectid" size="small" style="width: 140px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="隶属公司" v-if="activeName!=4 && activeName!=6 && activeName!=7 && activeName!=10">
              <el-input v-model="listQuery2.ContractParty" style="width: 140px;" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="证件号码">
              <el-input v-model="listQuery2.MainlinsuredCardId" style="width: 140px;" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="审批时间" v-if="activeName==4 || activeName==6 || activeName==7 || activeName==10">
              <el-date-picker type="date" placeholder="" v-model="listQuery2.ApprovalStartTime" value-format="yyyy-MM-dd" style="width:140px" size="small"></el-date-picker>
              <span> ~ </span>
              <el-date-picker type="date" placeholder="" v-model="listQuery2.ApprovalEndTTime" value-format="yyyy-MM-dd" style="width:140px" size="small"></el-date-picker>
            </el-form-item>
          </el-form>
          <div class="screenInput" v-if="activeName==4 || activeName==2">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1 && (activeName==4 || activeName==2)">
      <div class="pro_down_box">
        <el-form :inline="true" class="re_down_form" label-width="110px">
          <el-form-item label="隶属公司" v-if="activeName==4">
            <el-input v-model="listQuery2.ContractParty" style="width: 140px;" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="实名是否通过" size="small" v-if="activeName == '2' && type=='add'">
            <el-select v-model="listQuery2.isPassCheck" placeholder="" style="width: 140px;" size="small" filterable clearable>
              <el-option label="所有" value=""></el-option>
              <el-option label="通过" value="通过"></el-option>
              <el-option label="不通过" value="不通过"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" type="success" @click="searchHandle">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>商保管理</el-breadcrumb-item>
          <el-breadcrumb-item>审核端</el-breadcrumb-item>
          <el-breadcrumb-item>{{type=='add' ? '报增' : '报减'}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="background-color: #fff;">
        <tabs :name="name" @changeType="changeType"></tabs>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="type=='add' ? ( '报增待核（' + approveNum + '）' ) : ( '报减待核（' + approveNum + '）' ) " name="2"></el-tab-pane>
          <el-tab-pane :label="type=='add' ? ( '报增被退回（' + returnNum + '）' ) : ( '报减被退回（' + returnNum + '）' )" name="3"></el-tab-pane>
          <el-tab-pane :label="'审批通过（' + passNum + '）'" name="4"></el-tab-pane>
          <el-tab-pane :label="'保司成功（' + successNum + '）'" name="6"></el-tab-pane>
          <el-tab-pane :label="'保司失败（' + failNum + '）'" name="7"></el-tab-pane>
          <el-tab-pane label="保司失败日志" name="8"></el-tab-pane>
          <el-tab-pane :label="type=='add' ? ( '报增历史数据（' + histotyNum + '）' ) : ( '报减历史数据（' + histotyNum + '）' )" name="5"></el-tab-pane>
          <el-tab-pane :label="'不联网（' + noNetNum + '）'" name="10"></el-tab-pane>
        </el-tabs>

        <!-- <el-popconfirm title="请确认是否提交本月初保审核？" @confirm="firstInsure">
          <el-button slot="reference" type="primary" size="small" style="margin-right: 15px;margin-bottom: 10px;">提交初保审批</el-button>
        </el-popconfirm> -->

        <el-button type="success" size="small" @click="batchApprove" v-if="activeName==2">&nbsp;批量审批</el-button>

        <el-button slot="reference" type="success" size="small" style="margin-right: 15px;margin-bottom: 10px;" v-if="totalCount>0" v-preventReClick @click="expList()">导出列表</el-button>

        <el-button slot="reference" type="success" size="small" style="margin-right: 15px;margin-bottom: 10px;" v-if="(activeName==4 || activeName==6 || activeName==7 || activeName==10) && totalCount>0" v-preventReClick @click="expBatchDtlList()">导出明细列表</el-button>

        <!-- 汇总 -->
        <el-table :data="tableData2" key="table2" border class="doc_table" v-loading="loading" :element-loading-text="progress>=0 && progress!='' ? '审批中' + progress + '%' : ''" @selection-change="handleSelectionChange" style="width:100%">
          <el-table-column type="selection" width="40" fixed="left">
          </el-table-column>
          <el-table-column prop="CheckMsg" label="实名认证" align="center" width="90" v-if="activeName == '2' && type=='add'" fixed="left">
            <template slot-scope={row}>
              <span v-if="!row.CheckMsg" class="status-tag success">已通过</span>
              <el-tooltip class="item" effect="dark" :content="'未通过原因：' + row.CheckMsg" placement="top-start" v-else>
                <span class="status-tag danger">未通过</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="BatchNum" label="投保批次号" :show-overflow-tooltip="true" align="center" width="110" fixed="left">
          </el-table-column>
          <el-table-column prop="Projectid" label="项目ID" align="center" width="65">
          </el-table-column>
          <el-table-column prop="ProjectName" label="项目名称" :show-overflow-tooltip="true" align="center" width="110">
          </el-table-column>
          <el-table-column prop="DepartmentName" label="部门" :show-overflow-tooltip="true" align="center" width="110">
          </el-table-column>
          <el-table-column prop="Service" label="客服" :show-overflow-tooltip="true" align="center" width="110">
          </el-table-column>
          <!-- <el-table-column prop="Name" label="项目批次号" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="InsuranceName" label="险种名称" :show-overflow-tooltip="true" align="center" width="160">
          </el-table-column>
          <el-table-column prop="ContractParty" label="隶属公司" :show-overflow-tooltip="true" align="center" width="160">
          </el-table-column>
          <el-table-column prop="CreateTime" label="提交时间" :show-overflow-tooltip="true" align="center" width="110px">
            <template slot-scope={row}>{{ row.CreateTime ? row.CreateTime.split('T')[0] : ''}}</template>
          </el-table-column>
          <el-table-column prop="UpdataTime" label="审批通过时间" align="center" width="110px" v-if="activeName==4">
            <template slot-scope={row}>{{ row.UpdataTime ? row.UpdataTime.split('T')[0] : ''}}</template>
          </el-table-column>
          <el-table-column prop="PendingAudit" label="待审核数" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ApproverState" label="状态" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Operator" label="操作人" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="OperationalSource" label="来源" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ReturnReasons" label="退回原因" align="center" min-width="200px" v-if="activeName==3" fixed="right">
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" :min-width="activeName==2 ? '260px' : activeName==3 ? '240px' : '170px'">
            <template slot-scope={row,$index}>
              <div class="eleTabBtn">
                <el-popover placement="right" :ref="'pop' + $index" width="1051" trigger="manual" style="margin-right: 10px;">
                  <div style="margin-bottom: 10px;">
                    <i class="el-icon-close cp" style="float: right;font-size: 20px;" @click="closePopover($index)"></i>
                  </div>
                  <div class="flex">
                    <el-form>
                      <el-form-item label="身份证号码" label-width="90px">
                        <el-input v-model="detailQuery.MainlinsuredCardId" style="width:200px" size="small" clearable></el-input>
                        <el-button type="success" size="small" v-preventReClick @click="getApprovalDetails()" style="margin-left: 15px;">搜索</el-button>

                        <el-button type="primary" size="small" v-preventReClick @click="expDtlList()" style="margin-left: 15px;">导出明细列表</el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                  <el-table :data="detailTable" border v-loading="detLoading" class="doc_table">
                    <el-table-column width="110" property="BatchNum" label="批次号" align="center"></el-table-column>
                    <el-table-column width="80" property="EmployeeAttribute" label="员工属性" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="156" property="MainlinsuredCardId" label="证件号码" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="80" property="MainlinsuredName" label="姓名" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="160" property="ProjectName" label="项目名称" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="100" property="JobName" label="岗位" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="80" property="JobClasss" label="职业类别" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="115" property="MainlinsuredPhone" label="手机号码" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="200" property="LaborContractUnit" label="劳动合同公司" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="120" property="ActualWorkUnit" label="工作单位" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="150" property="InsuranceName" label="险种名称" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <!-- <el-table-column width="100" property="OrderNum" label="订单号" :show-overflow-tooltip="true" align="center"></el-table-column> -->
                    <el-table-column width="100" property="CreateTime" label="申请时间" align="center">
                      <template slot-scope={row}>
                        {{ row.CreateTime ? row.CreateTime.split('T')[0] : '' }}
                      </template>
                    </el-table-column>
                    <el-table-column width="100" property="InsuranceStartTime" label="保障开始" align="center">
                      <template slot-scope={row}>
                        {{ row.InsuranceStartTime ? row.InsuranceStartTime.split('T')[0] : '' }}
                      </template>
                    </el-table-column>
                    <el-table-column width="100" property="InsuranceEndTime" label="保障结束" align="center">
                      <template slot-scope={row}>
                        {{ row.InsuranceEndTime ? row.InsuranceEndTime.split('T')[0] : '' }}
                      </template>
                    </el-table-column>
                    <el-table-column width="100" v-if="activeName == 7" property="InsuredErrMsg" label="失败原因" align="center" fixed="right">
                    </el-table-column>
                    <el-table-column width="90" label="操作" align="center" fixed="right">
                      <template slot-scope={row}>
                        <div class="eleTabBtn">
                          <!-- <el-button type="text" @click="editBackDtl(row)">编辑</el-button>
                          <el-button type="text" @click="delBackDtl(row)">删除</el-button> -->
                          <el-button type="text" v-preventReClick @click="editDtl(row)" v-if="activeName==2 && row.CheckState==1 && type=='add'">编辑</el-button>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="block">
                    <el-pagination v-if="detTotal>0" @current-change="detCurrentChange" :current-page.sync="detailQuery.pageNum" :page-size="Number(detailQuery.pageSize)" @size-change="detHandleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="detTotal"></el-pagination>
                  </div>
                  <el-button type="text" slot="reference" v-preventReClick @click="getDetail(row,$index)">查看明细</el-button>
                </el-popover>
                <el-button type="text" v-preventReClick @click="reimport(row)" v-if="activeName==3">重新导入</el-button>
                <el-button type="text" v-preventReClick @click="resubmit(row)" v-if="activeName==3">重新提交</el-button>
                <el-button type="text" v-preventReClick @click="resubmitFail(row)" v-if="activeName==7">重新提交</el-button>
                <el-button type="text" v-if="activeName==2" @click="approve(row)">审批</el-button>
                <el-button type="text" v-if="activeName==2" @click="goBack(row)">退回</el-button>
                <el-button type="text" v-if="activeName==2 && row.CheckMsg" @click="passAuth(row)">通过认证</el-button>
                <el-popconfirm v-if="activeName==2" :title="'请确定批次号为' + row.BatchNum + ' 的是否作废？'" @confirm="approverCancel(row)" style="margin-left: 10px;">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0 && Number(activeName) >1 && verifiedType=='sum'" @current-change="currentChange2" :current-page.sync="listQuery2.pageNum" :page-size="Number(listQuery2.pageSize)" @size-change="handleSizeChange2" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>

      </div>
    </div>

    <!-- 编辑信息 -->
    <el-dialog title="编辑信息" :visible.sync="showEditBackDtl" width="990px">
      <div class="backDtlInfo">
        <el-form :model="backDtlInfo" :inline="true" ref="backDtlInfo" label-width="130px" :rules="backRules">

          <el-form-item label="员工属性" prop="EmployeeAttribute">
            <el-select v-model="backDtlInfo.EmployeeAttribute" placeholder="" clearable size="small" style="width:300px">
              <el-option value="长期工"></el-option>
              <el-option value="临时工"></el-option>
              <el-option value="日结工"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="证件类型" prop="Idtype">
            <el-select v-model="backDtlInfo.Idtype" placeholder="" clearable size="small" style="width:300px">
              <el-option value="身份证"></el-option>
              <el-option value="护照"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="证件号码" prop="MainlinsuredCardId">
            <el-input v-model="backDtlInfo.MainlinsuredCardId" style="width:300px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="姓名" prop="MainlinsuredName">
            <el-input v-model="backDtlInfo.MainlinsuredName" style="width:300px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="岗位" prop="JobName">
            <el-input v-model="backDtlInfo.JobName" style="width:300px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="职业类别" prop="JobClasss">
            <el-select v-model="backDtlInfo.JobClasss" placeholder="" clearable size="small" style="width:300px">
              <el-option value="1-4类"></el-option>
              <el-option value="5类"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="手机号码" prop="MainlinsuredPhone">
            <el-input v-model="backDtlInfo.MainlinsuredPhone" style="width:300px" size="small"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditBackDtl = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmEditBackDtl" size="small">提 交</el-button>
      </span>
    </el-dialog>

    <div class="insureApprove">
      <!-- 审批 -->
      <el-dialog title="审批确认" :visible.sync="showApprove" width="500px">
        <span>请确认批次为 <span style="font-weight: 600;">{{approveBatch}}</span> 是否通过审批？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showApprove = false" size="small">取 消</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmPass" size="small">通 过</el-button>
        </span>
      </el-dialog>

      <!-- 退回 -->
      <el-dialog title="退回确认" :visible.sync="showBack" width="500px">
        <div style="margin-bottom: 15px;">请确认批次为 {{approveBatch}} 是否退回？</div>
        <el-form label-width="68px">
          <el-form-item label="退回原因">
            <el-input v-model="ReturnReasons" style="width:300px" size="small"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showBack = false" size="small">取 消</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmBack" size="small">确 认</el-button>
        </span>
      </el-dialog>

      <!-- 删除 -->
      <el-dialog title="删除确认" :visible.sync="showDel" width="500px">
        <div style="margin-bottom: 15px;">请确认是否删除 {{ delName }} ？ </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showBack = false" size="small">取 消</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmDel" size="small">确认</el-button>
        </span>
      </el-dialog>

      <!-- 重新提交审批 -->
      <el-dialog title="重新提交审批" :visible.sync="showResubmit" width="500px">
        <span>请确认批次为 {{approveBatch}} 是否重新提交审批？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showResubmit = false" size="small">取 消</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmResubmit" size="small">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 重新导入 -->
      <el-dialog title="重新导入" :visible.sync="showReimport" width="500px">
        <el-form label-width="80px">
          <el-form-item label="导入Excel">
            <div class="file-box">
              <input readonly style="width: 300px;height:32px;margin-top: 4px;" id="applyLicense" type="text" v-model="fileName" autocomplete="off">
              <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
              <label for="fileInput" class="file-btn cp">上传</label>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showReimport = false" size="small">取 消</el-button>
          <el-button type="primary" v-preventReClick :disabled="!reimportForm.userListFile" style="margin-left:10px;" @click="confirmReimport" size="small">确 认</el-button>
        </span>
      </el-dialog>

      <!-- 编辑信息 -->
      <el-dialog title="编辑信息" :visible.sync="showEditDtl" width="500px">
        <div class="backDtlInfo">
          <el-form :model="DtlInfo" ref="DtlInfo" label-width="130px" :rules="backRules">

            <el-form-item label="证件号码" prop="MainlinsuredCardId">
              <el-input v-model="DtlInfo.MainlinsuredCardId" style="width:300px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="姓名" prop="MainlinsuredName">
              <el-input v-model="DtlInfo.MainlinsuredName" style="width:300px" size="small"></el-input>
            </el-form-item>

          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showEditDtl = false" size="small">取 消</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmEditDtl" size="small">提 交</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import tabs from "./components/examineTabs.vue";
  export default {
    components: {
      tabs
    },
    data() {
      var validatetInsuranceTime = (rule, value, callback) => {
        if (!this.declareForm.Insurance.InsuranceStartTime) {
          callback(new Error("请选择保障开始时间"));
        } else if (!this.declareForm.Insurance.InsuranceStartTime) {
          callback(new Error("请选择保障结束时间"));
        } else {
          callback();
        }
      };
      return {
        name: '/reportIncrease',
        listQuery: {
          pageNum: 1,
          pageSize: 10
        },
        showDropScreen: -1,
        roletype: localStorage.loginRoletype,
        type: 'add', //报增or报减
        activeName: '2',
        verifiedType: 'sum', //汇总/明细
        loading: false,
        tableData: [],
        proName: '',
        insuranceName: '', //险种名称
        MedicalinsuranceType: '', //医保类型
        validityStartTime: '', //保障期限
        validityEndTime: '',
        declareForm: { //报增减表单
          Insurance: {
            BusinessType: 1, //1报增 0 报减
            InsuranceId: '', //险种id
            ProjectName: '', //项目名称
            OrderNum: '', //订单号
            Projectid: '', //项目id
            InsuranceStartTime: '', //保险期限
            InsuranceEndTime: '',
          },
          userList: [{
            MainlinsuredName: '', //姓名
            MainlinsuredCardId: '', //证件号
            IDType: '', //证件类型
            MainlinsuredPhone: '', //手机号码
            JobName: '', //岗位名称
            JobClasss: '', //职业类别
            EmployeeAttribute: '', //员工属性
          }]
        },
        fileName: '', //文件名称
        proNameList: [], //项目列表
        showDeclare: false, //增/减员弹窗
        showBatchDeclare: false, //批量增减员弹窗
        listQuery2: {
          Projectid: '', //项目
          ContractParty: '', //隶属公司
          BusinessType: 1, //报增/报减
          ApprovalStartTime: '', //审批时间 开始
          ApprovalEndTTime: '', //审批时间 结束
          ApproverState: '待审核', //审批状态
          MainlinsuredCardId: '', //身份证号码
          pageNum: 1,
          pageSize: 10
        },
        tableData2: [],
        totalCount: 0,
        detailQuery: {
          Id: '',
          MainlinsuredCardId: '', //身份证号码
          ServiceProviderStatu: '', //保司失败参数
          pageNum: 1,
          pageSize: 10
        },
        detTotal: 0,
        approveIds: '', //审批ID
        approveBatch: '', //批次
        showApprove: false, //审批弹窗
        detailTable: [], //明细
        detTotal: 0, //明细总数
        detLoading: false,
        batchForm: {
          Insurance: {
            ProjectName: '',
            InsuranceId: '',
            OrderNum: '',
            InsuranceStartTime: '',
            InsuranceEndTime: '',
            Projectid: '',
          },
          userListFile: '',
        },
        isUploadSuccess: false, //是否上传成功
        ispending: false,
        JobClasssList: ['1-4类', '5类'],
        JobNameTip: '需要具体细化，参考《职业分类表》进行填写',
        JobClasssTip: '参考《职业分类表》',
        showBack: false, //退回弹窗
        ReturnReasons: '', //退回原因
        policy: '', //可参保时间段
        policyList: [], //可参保时间段列表
        policy2: '',
        approveNum: 0, //待审批数量
        returnNum: 0, //退回数量
        passNum: 0, //通过数量
        successNum: 0, //保司成功数量
        failNum: 0, //保司失败数量
        histotyNum: 0, //历史数据数量
        noNetNum: 0, //不联网数量
        multipleSelection: [],
        backDtlInfo: {
          Id: '',
          MainlinsuredName: '',
          Idtype: '',
          MainlinsuredCardId: '',
          MainlinsuredPhone: '',
          JobName: '',
          EmployeeAttribute: '',
          JobClasss: '',
        },
        showEditBackDtl: false, //退回明细个人编辑弹窗
        backRules: {
          'EmployeeAttribute': {
            required: true,
            message: "请选择证件类型",
            trigger: "change",
          },
          'Idtype': {
            required: true,
            message: "请选择员工属性",
            trigger: "change",
          },
          'MainlinsuredCardId': {
            required: true,
            message: "请输入证件号码",
            trigger: "blur",
          },
          'MainlinsuredName': {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
          'JobName': {
            required: true,
            message: "请输入岗位",
            trigger: "blur",
          },
          'JobClasss': {
            required: true,
            message: "请选择职业类别",
            trigger: "blur",
          },
          'MainlinsuredPhone': {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
        },
        showDel: false,
        delId: '',
        delName: '',
        showResubmit: false,
        showReimport: false,
        reimportForm: {
          userListFile: '', //查询导入文件BASE64
          oldid: '', //重新导入ID
        },
        progress: '',
        progresId: '',
        interval: null,
        showEditDtl: false,
        DtlInfo: {
          Id: '',
          ParentId: '',
          MainlinsuredName: '',
          MainlinsuredCardId: '',
        },
      }
    },
    created() {
      if (this.$route.query.type != undefined && this.$route.query.type) {
        this.type = this.$route.query.type;
        localStorage.setItem("insureActive", this.$route.query.type)
        this.declareForm.Insurance.BusinessType = this.$route.query.type == 'add' ? 1 : 0;
        this.listQuery2.BusinessType = this.$route.query.type == 'add' ? 1 : 0;
        this.listQuery2.ApproverState = '待审核';
      } else {
        localStorage.setItem("insureActive", 'add')
      }
      this.getProList();
      this.getPolicyList();
      this.getApprovalByProjectPower();
    },
    methods: {
      checkPermission,
      searchHandle() {
        this.getApprovalByProjectPower()
      },
      handleClick() {
        if (this.activeName == '2') {
          this.listQuery2.ApproverState = '待审核';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '3') {
          this.listQuery2.ApproverState = '退回';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '4') {
          this.listQuery2.ApproverState = '审批通过';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '5') {
          this.listQuery2.ApproverState = '';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '6') {
          this.listQuery2.ApproverState = '保司成功';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '7') {
          this.listQuery2.ApproverState = '保司失败';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '8') {
          this.listQuery2.ApproverState = '保司失败日志';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '10') {
          this.listQuery2.ApproverState = '不联网';
          this.getApprovalByProjectPower()
        }
      },
      //切换增/减员状态
      changeType(val) {
        this.listQuery2.ApprovalStartTime = '';
        this.listQuery2.ApprovalEndTime = '';
        this.type = val;
        console.log(val)
        this.$nextTick(() => {
          this.activeName = '2';
        })
        if (val == 'add') { //报增
          this.declareForm.Insurance.BusinessType = 1;
          this.listQuery2.BusinessType = 1;
          this.listQuery2.ApproverState = '待审核';
          this.getApprovalByProjectPower();
        } else { //报减
          this.declareForm.Insurance.BusinessType = 0;
          this.listQuery2.BusinessType = 0;
          this.listQuery2.ApproverState = '待审核';
          this.getApprovalByProjectPower();
        }
      },
      //获取可参保时间段列表
      getPolicyList() {
        let data = {
          insurable: 1,
          pageNum: 1,
          pageSize: 1000,
        }
        xz.getOrderPolicyManageList(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.policyList = res.data.list;
          } else {
            this.policyList = []
          }
        })
      },
      policyChange(val) {
        this.declareForm.Insurance.InsuranceStartTime = val.CoverStartTime;
        this.declareForm.Insurance.InsuranceEndTime = val.CoverEndTime;
      },
      policyChange2(val) {
        this.batchForm.Insurance.InsuranceStartTime = val.CoverStartTime;
        this.batchForm.Insurance.InsuranceEndTime = val.CoverEndTime;
      },
      //下载模板
      downImportTemp() {
        xz.getInsureImportTemplate(this.batchForm.Insurance.InsuranceId, this.roletype).then((res) => {
          if (res.status == "ok") {
            let q = this.type == 'add' ? '批量报增导入模板' : '批量报减导入模板'
            let name = this.insuranceName + '-' + q + '.xls';
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/xls`
            })
            let aLink = document.createElement("a")
            aLink.download = name; //这里写保存时的文件名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
          } else {
            this.$message.error('获取模板失败')
          }
        });
      },
      //文件读取
      async importf() {
        const fileInput = this.$refs.upload;
        this.fileName = fileInput.files[0].name;
        FUN.fileToBase64(fileInput.files[0]).then(res => {
          if (res) {
            this.reimportForm.userListFile = res;
          } else {
            this.$message("上传Excel失败!");
            this.reimportForm.userListFile = '';
            this.$refs['upload'].value = null;
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          pageSize: 100000000,
          pageNum: 1,
          StrprojectName: ''
        }
        xz.getProjectAllLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //获取待审核/退回/通过列表
      getApprovalByProjectPower() {
        this.loading = true;
        xz.getApprovalByUserId(this.listQuery2, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tableData2 = res.data.ret;
            this.totalCount = res.data.totalCount;
            this.loading = false;
            this.approveNum = 0; //待审核数量
            this.returnNum = 0; //退回数量
            this.passNum = 0; //通过数量
            this.successNum = 0;
            this.failNum = 0;
            this.noNetNum = 0;
            this.histotyNum = 0; //历史数据数量
            if (res.data.collect.length > 0) {
              res.data.collect.forEach(element => {
                if (element.ApproverState == '待审核') {
                  this.approveNum = element.Count
                } else if (element.ApproverState == '审批通过') {
                  this.passNum = element.Count
                } else if (element.ApproverState == '退回') {
                  this.returnNum = element.Count
                } else if (element.ApproverState == '保司成功') {
                  this.successNum = element.Count
                } else if (element.ApproverState == '保司失败') {
                  this.failNum = element.Count
                } else if (element.ApproverState == '不联网') {
                  this.noNetNum = element.Count
                }
                this.histotyNum = this.approveNum + this.passNum + this.returnNum + this.successNum + this.failNum;
              });
            }
          } else {
            this.loading = false;
            this.$message.error('系统出错！');
            this.tableData2 = [];
          }
        })
      },
      currentChange2(val) {
        this.listQuery2.pageNum = Number(val);
        this.getApprovalByProjectPower();
      },
      handleSizeChange2(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery2.pageNum = 1;
        this.listQuery2.pageSize = val;
        this.getApprovalByProjectPower();
      },
      //查看明细
      getDetail(row, index) {
        if (this.activeName == 7 || this.activeName == 8) {
          this.detailQuery.ServiceProviderStatu = 0;
        } else {
          this.detailQuery.ServiceProviderStatu = '';
        }
        let ref = 'pop' + index;
        this.$refs[ref].doShow();
        this.detailQuery.Id = row.Id;
        this.detailQuery.pageNum = 1;
        this.detailQuery.MainlinsuredCardId = '';
        this.getApprovalDetails();
      },
      //获取明细列表
      getApprovalDetails() {
        this.detLoading = true;
        xz.getApprovalDetails(this.detailQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.detailTable = res.data.ret;
            this.detTotal = res.data.totalCount;
            this.detLoading = false;
          } else {
            this.detLoading = false;
            this.detailTable = [];
            this.detTotal = 0;
            this.$message.error('系统出错！');
          }
        })
      },
      detCurrentChange(val) {
        this.detailQuery.pageNum = Number(val);
        this.getApprovalDetails();
      },
      detHandleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.detailQuery.pageNum = 1;
        this.detailQuery.pageSize = val;
        this.getApprovalDetails();
      },
      //审批
      approve(row) {
        this.approveIds = row.Id;
        this.approveBatch = row.BatchNum;
        this.showApprove = true;
      },
      //确认审批通过
      confirmPass() {
        this.progress = '';
        this.loading = true;
        xz.approvalEnd(this.approveIds, this.roletype).then(res => {
          if (res.status == 'ok') {
            // if (res.data != undefined && res.data) {
            //   this.progress = 0;
            //   this.progresId = res.data;
            //   this.interval = setInterval(this.getApprovalProgress, 5000)
            // } else {
            this.progress = '';
            this.$message.success('审批成功');
            this.getApprovalByProjectPower();
            this.loading = false;
            // }
            this.showApprove = false;
          } else {
            this.loading = false;
            this.showApprove = false;
            this.$message.error(res.msg);
          }
        })
      },
      //获取审批进度
      getApprovalProgress() {
        xz.getApprovalProgress(this.progresId, this.roletype).then(res => {
          if (res.status == 'ok') {
            if (res.data.currentNum == res.data.total) {
              clearInterval(this.interval)
              this.progress = '';
              this.loading = false;
              this.$message.success(res.data.msg)
              this.getApprovalByProjectPower();
            }
            this.progress = (res.data.currentNum / res.data.total * 100).toFixed(0);
            console.log(this.progress)
          } else {
            this.loading = false;
            clearInterval(this.interval)
            this.getApprovalByProjectPower();
            this.progress = '';
            this.$message.error('获取审批进度失败')
          }
        })
      },
      //退回
      goBack(row) {
        this.approveIds = row.Id;
        this.approveBatch = row.BatchNum;
        this.showBack = true;
      },
      //确认退回
      confirmBack() {
        let data = {
          id: this.approveIds,
          ReturnReasons: this.ReturnReasons
        }
        xz.approvalReturn(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('退回成功');
            this.getApprovalByProjectPower();
            this.showBack = false;
          } else {
            this.showBack = false;
            this.$message.error('系统出错！');
          }
        })
      },
      //初保
      firstInsure() {
        if (!this.ispending) {
          this.ispending = true;
          xz.applyInsured('', this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('初保提交成功')
              setTimeout(() => {
                this.ispending = false;
              }, 1000);
            } else {
              this.$message.error('系统出错！');
            }
          })
        }
      },
      //查看资料详情
      getTipDtl() {
        console.log('ddd')
      },
      //导出列表
      expList() {
        this.loading = true;
        let data = {
          IsExport: '1',
          BusinessType: this.listQuery2.BusinessType,
          pageNum: 1,
          pageSize: 10000
        }
        xz.getApprovalByUserId(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a");
            let type = this.type == 'add' ? '报增' : '报减';
            let name = this.activeName == 2 ? '待核' : this.activeName == 3 ? '被退回' : this.activeName == 4 ? '审核通过' : '历史数据';
            aLink.download = '审核端-' + type + name + '列表.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.loading = false;
          } else {
            this.$message.error('导出失败')
            this.loading = false;
          }
        })
      },
      //导出明细列表
      expDtlList() {
        let data = {
          IsExport: '1',
          Id: this.detailQuery.Id,
          pageNum: 1,
          pageSize: 10000
        }
        this.detLoading = true;
        xz.getApprovalDetails(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.detLoading = false;
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a");
            let type = this.type == 'add' ? '报增' : '报减';
            let name = this.activeName == 2 ? '待核' : this.activeName == 3 ? '被退回' : this.activeName == 4 ? '审核通过' : this.activeName == 10 ? '不联网' : '历史数据';
            aLink.download = type + name + '明细列表.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.detLoading = false;
          } else {
            this.detLoading = false;
            this.$message.error('导出失败！');
          }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //批量审批
      batchApprove() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请先选择批次！')
        } else {
          this.approveIds = '';
          this.approveBatch = '';
          this.multipleSelection.forEach((element, index) => {
            if (index == 0) {
              this.approveIds = element.Id;
              this.approveBatch = element.BatchNum;
            } else {
              this.approveIds = this.approveIds + ',' + element.Id;
              this.approveBatch = this.approveBatch + ',' + element.BatchNum;
            }
          })
          this.showApprove = true;
        }
      },
      //退回明细个人编辑
      editBackDtl(row) {
        this.backDtlInfo = {
          Id: row.Id,
          MainlinsuredName: row.MainlinsuredName,
          MainlinsuredCardId: row.MainlinsuredCardId,
          Idtype: row.Idtype,
          MainlinsuredPhone: row.MainlinsuredPhone,
          JobName: row.JobName,
          EmployeeAttribute: row.EmployeeAttribute,
          JobClasss: row.JobClasss,
        }
        this.showEditBackDtl = true;
      },
      confirmEditBackDtl() {
        this.$refs["backDtlInfo"].validate((valid) => {
          if (valid) {
            xz.updataApprovalDetail(this.backDtlInfo, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.getApprovalDetails();
                this.showEditBackDtl = false;
                this.$message.success('修改成功！');
              } else {
                this.showEditBackDtl = false;
                this.$message.error('系统出错！');
              }
            })
          }
        })
      },
      delBackDtl(row) {
        this.delId = row.Id;
        this.delName = row.MainlinsuredName;
        this.showDel = true;
      },
      confirmDel() {
        xz.delApprovalDetail(this.delId, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getApprovalDetails();
            this.showDel = false;
            this.$message.success('作废成功！');
          } else {
            this.showDel = false;
            this.$message.error('系统出错！');
          }
        })
      },
      // 删除待核数据
      approverCancel(row) {
        xz.approverCancel(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getApprovalByProjectPower();
            this.showDel = false;
            this.$message.success('作废成功！');
          } else {
            this.showDel = false;
            this.$message.error('系统出错！');
          }
        })
      },
      //重新提交审批
      resubmit(row) {
        this.approveIds = row.Id;
        this.approveBatch = row.BatchNum;
        this.showResubmit = true;
      },
      confirmResubmit() {
        xz.submitApproval(this.approveIds, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getApprovalByProjectPower();
            this.showResubmit = false;
            this.$message.success('提交成功！');
          } else {
            this.showResubmit = false;
            this.$message.error('系统出错！');
          }
        })
      },
      //重新导入
      reimport(row) {
        this.reimportForm.oldid = row.Id;
        this.showReimport = true;
        this.fileName = '';
      },
      confirmReimport() {
        xz.reportAddApprov(this.reimportForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$refs['upload'].value = null;
            this.getApprovalByProjectPower();
            this.showReimport = false;
            this.$message.success('重新导入成功！');
          } else {
            this.$refs['upload'].value = null;
            this.showResubmit = false;
            this.$message.error('系统出错！');
          }
        })
      },
      //关闭明细
      closePopover(index) {
        let ref = 'pop' + index;
        this.$refs[ref].doClose();
      },
      //批量导出明细
      expBatchDtlList() {
        if (this.multipleSelection.length == 0) {
          // this.$message.warning('请先选择批次！')
          let data = {
            IsExport: '1',
            Id: '',
            pageNum: 1,
            pageSize: 100000
          }
          if (this.activeName == 6 || this.activeName == 7) {
            this.expICS()
          } else {
            this.exports(data)
          }
        } else {
          let ids = '';
          this.multipleSelection.forEach((element, index) => {
            if (index == 0) {
              ids = element.Id;
            } else {
              ids = ids + ',' + element.Id;
            }
            if (index == this.multipleSelection.length - 1) {
              let data = {
                IsExport: '1',
                Id: ids,
                pageNum: 1,
                pageSize: 100000
              }
              if (this.activeName == 6 || this.activeName == 7) {
                this.expICS()
              } else {
                this.exports(data)
              }
            }
          })
        }
      },
      exports(data) {
        this.detLoading = true;
        xz.getApprovalDetails(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.detLoading = false;
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a");
            let type = this.type == 'add' ? '报增' : '报减';
            let name = this.activeName == 2 ? '待核' : this.activeName == 3 ? '被退回' : this.activeName == 4 ? '审核通过' : this.activeName == 10 ? '不联网' : '历史数据';
            aLink.download = type + name + '明细列表.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.detLoading = false;
          } else {
            this.detLoading = false;
            this.$message.error('导出失败！');
          }
        })
      },
      //导出保司成功明细
      expICS() {
        let data = {
          IsExport: '1',
          Id: '',
          BusinessType: this.type == 'add' ? 1 : 0,
          ApprovalStartTime: this.listQuery2.ApprovalStartTime,
          ApprovalEndTTime: this.listQuery2.ApprovalEndTTime,
          pageNum: 1,
          pageSize: 100000
        }
        this.detLoading = true;
        xz.GetApprovalSuccess(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.detLoading = false;
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a");
            let name = this.activeName == 6 ? '保司成功' : this.activeName == 7 ? '保司失败' : '';
            aLink.download = name + '明细列表.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.detLoading = false;
          } else {
            this.detLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      resubmitFail(row) {
        xz.ReSubmitFail({
          id: row.Id
        }, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getApprovalByProjectPower();
            this.showResubmit = false;
            this.$message.success('提交成功！');
          } else {
            this.showResubmit = false;
            this.$message.error('系统出错！');
          }
        })
      },
      passAuth(row) {
        this.loading = true;
        xz.PassApplyInfo([{
          id: row.Id
        }], this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getApprovalByProjectPower();
            this.loading = false;
            this.$message.success('操作成功！');
          } else {
            this.loading = false;
            this.$message.error('系统出错！');
          }
        })
      },
      //编辑
      editDtl(row) {
        this.DtlInfo = {
          Id: row.Id,
          ParentId: row.ParentId,
          MainlinsuredName: row.MainlinsuredName,
          MainlinsuredCardId: row.MainlinsuredCardId,
        }
        this.showEditDtl = true;
      },
      confirmEditDtl() {
        this.$refs["DtlInfo"].validate((valid) => {
          if (valid) {
            xz.UpdateApplyInfo([this.DtlInfo], this.roletype).then(res => {
              if (res.status == 'ok') {
                this.getApprovalDetails();
                this.showEditDtl = false;
                this.$message.success('修改成功！');
              } else {
                this.showEditDtl = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  .file-box {
    position: relative;
    display: flex;
    align-items: center;
  }

  .file-box input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
  }

  .file-btn {
    display: inline-block;
    width: 54px;
    height: 28px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center !important;
    line-height: 28px;
    color: #333333;
    margin-left: 8px;
    margin-top: 4px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .status-tag {
    display: inline-block;
    padding: 4px 10px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 4px;
    color: #fff;
  }

  .success {
    background-color: #67c23a;
  }

  .danger {
    background-color: #f56c6c;
  }
</style>
<style>
  .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_declare .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_declare .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_declare .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_declare .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_declare .declareForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_declare .declareForm .el-form-item__error {
    top: 34px;
  }

  .insureApprove .el-dialog__body {
    padding: 10px 20px;
  }
</style>